import React, { useState } from 'react';

import Carousel from 'react-bootstrap/Carousel';

import repairShop from '../../images/repair_shop.jpeg'
import pristineClean from '../../images/pristine-clean.jpeg'
import HiKamp from '../../images/HiKamp.jpeg';
import superSnake from '../../images/super_snake.jpg'
import social_network_api from '../../images/social_network_api.jpeg';

import '../../styles/Portfolio.css';


function Portfolio() {

    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    return (
        <div className="container align-middle p-2 bg-dark" style={{ maxWidth: "650px", height: "75vh"}} >
            <Carousel activeIndex={index} onSelect={handleSelect} variant="dark" style={{ minHeight: "fit-content" }}>
            <Carousel.Item className="align-middle p-2" style={{ }}>
                    <img
                        className="d-block w-100 max-vh-75"
                        src={repairShop}
                        alt="First slide: Repair Shop "
                        style= {{ objectFit: "contain" }}
                    />
                    <Carousel.Caption className="rounded bg-dark bg-opacity-75 text-light caption-box">
                        <h3>Repair Shop</h3>
                        <h5>SQL/Java/TypeScript<br></br>Spring Framework/React.js/Node.js<br></br>Spring Boot/Spring MVC/Spring Security<br></br>AWS/RDS/EC2/S3</h5>
                        <p>AS the owner of a repair business<br></br>I WANT an app to give stakeholders necessary tools and info<br></br>SO THAT I can manage with an SPA</p>
                        <a href="https://github.com/PatrickARatcliff/repair-shop" target="_blank" role="button" className="btn btn-info m-1">GitHub Repo</a>
                        <a href="http://repairshop.s3-website.us-east-2.amazonaws.com" target="_blank" role="button" className="btn btn-info m-1">AWS App</a>
                    </Carousel.Caption>
                </Carousel.Item>
            <Carousel.Item className="align-middle p-2" style={{ }}>
                    <img
                        className="d-block w-100 max-vh-75"
                        src={pristineClean}
                        alt="Second slide: Pristine Clean MERN"
                        style= {{ objectFit: "contain" }}
                    />
                    <Carousel.Caption className="rounded bg-dark bg-opacity-75 text-light caption-box">
                        <h3>Pristine Clean MERN</h3>
                        <h5>MongoDB/JavaScript<br></br>Express.js/React.js/Node.js</h5>
                        <p>AS owner of a commercial cleaning business<br></br>I WANT an application with tools and info necessary for various positions<br></br>SO THAT I can manage with an SPA</p>
                        <a href="https://github.com/stevecalla/pristine-clean-v2" target="_blank" role="button" className="btn btn-info m-1">GitHub Repo</a>
                        <a href="https://pristine-clean.herokuapp.com/" target="_blank" role="button" className="btn btn-info m-1">Heroku App</a>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item className="align-middle p-2">
                    <img
                        className="w-100 d-block max-h-50"
                        src={HiKamp}
                        alt="Third slide: HiKamp MVC"
                        style= {{ objectFit: "contain" }}
                    />
                    <Carousel.Caption className="rounded bg-dark bg-opacity-75 text-light caption-box">
                        <h3>HiKamp MVC</h3>
                        <h5>SQL/JavaScript<br></br>Sequelize/Express.js/Handlebars.js/Node.js<br></br></h5>
                        <p>Interactive app allows a user to easily search campgrounds within the United States National Park Service</p>
                        <a href="https://github.com/stevecalla/hiKamp" target="_blank" role="button" className="btn btn-info m-1">GitHub Repo</a>
                        <a href="https://hikamp.herokuapp.com/" target="_blank" role="button" className="btn btn-info m-1">Heroku App</a>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item className="align-middle p-2">
                    <img
                        className="d-block w-100 vh-80"
                        src={superSnake}
                        alt="Fourth slide: Super Snake"
                        style= {{ objectFit: "contain" }}
                    />
                    <Carousel.Caption className="rounded bg-dark bg-opacity-75 text-light caption-box">
                        <h3>Super Snake</h3>
                        <h5>p5.js/JavaScript</h5>
                        <p>Simple, entertaining, aesthetically and aubibly pleasing snake game!</p>
                        <a href="https://github.com/PatrickARatcliff/super_snake" target="_blank" role="button" className="btn btn-info m-1">GitHub Repo</a>
                        <a href="https://patrickaratcliff.github.io/super_snake/" target="_blank" role="button" className="btn btn-info m-1">GitHub Pages</a>
                        <a href="https://editor.p5js.org/PatrickARatcliff/full/0oFubilss" target="_blank" role="button" className="btn btn-info m-1">p5.js</a>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item className="align-middle p-2">
                    <img
                        className="d-block w-100 vh-50"
                        src={social_network_api}
                        alt="Fifth slide: Social Network API"
                        style= {{ objectFit: "contain" }}
                    />
                    <Carousel.Caption className="rounded bg-light bg-opacity-75 text-dark caption-box">
                        <h3>Social Network API</h3>
                        <h5>Express.js/MongoDB<br></br>Mongoose ODM</h5>
                        <p> API for a social network web application allows users to share thoughts, react to friends thoughts, and create a friends list</p>
                        <a href="https://github.com/PatrickARatcliff/m18c-social_network_api" target="_blank" role="button" className="btn btn-info mx-1">GitHub Repo</a>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </div>
    );
}

export default Portfolio;
